import { render, staticRenderFns } from "./dichiarazioni.vue?vue&type=template&id=0ea2483b&scoped=true&"
import script from "./dichiarazioni.vue.ts?vue&type=script&lang=ts&"
export * from "./dichiarazioni.vue.ts?vue&type=script&lang=ts&"
import style0 from "./dichiarazioni.vue?vue&type=style&index=0&id=0ea2483b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea2483b",
  null
  
)

export default component.exports